import { useMutation } from '@tanstack/react-query';

import { SystemComponent } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/system/component/:componentId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: FormData;
    componentId: string;
    parkingId: string;
}
const mutationFn = ({ componentId, parkingId, data }: DTO): Promise<SystemComponent> => {
    return axios.patch(formatResourcePath(RESOURCE, { componentId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateComponent };
